import { render, staticRenderFns } from "./SalesEvolutionTable.vue?vue&type=template&id=144aafac&scoped=true"
import script from "./SalesEvolutionTable.vue?vue&type=script&lang=js"
export * from "./SalesEvolutionTable.vue?vue&type=script&lang=js"
import style0 from "./SalesEvolutionTable.vue?vue&type=style&index=0&id=144aafac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144aafac",
  null
  
)

export default component.exports